import type { Dispatch } from 'react';
import {
  SET_PLANNED_TWIN_ID_UPDATE_PLAN,
  RESET_PLANNED_TWIN_ID_UPDATE,
  SET_IS_APPLYING_PLANNED_TWIN_ID_UPDATE,
  SET_IS_PLANNING_PLANNED_TWIN_ID_UPDATE,
  SET_PLANNED_TWIN_ID_UPDATE_ERROR,
  SET_PLANNED_TWIN_ID_UPDATE_SHOW_CHANGES_ONLY,
  SET_PLANNED_TWIN_ID_UPDATE_MODE,
  SET_PLANNED_TWIN_ID_UPDATE_FILE,
  SET_EXISTING_PLANNED_TWIN_IDS,
} from './actionTypes';
import { analytics, fetchPlannedTwinIDs, updatePlannedTwinIDs } from '../services';
import { PlannedTwinIDUpdateMode } from '../config/constants';
import { PlannedTwinIDUpdateAction } from '../context';

const setPlannedTwinIDUpdateFile = (
  name: string,
  contents: string,
  dispatch: Dispatch<PlannedTwinIDUpdateAction>,
) => {
  dispatch({
    type: SET_PLANNED_TWIN_ID_UPDATE_FILE,
    payload: {
      name,
      contents,
    },
  });
};

const setIsPlanningPlannedTwinIDUpdate = (
  status: boolean,
  dispatch: Dispatch<PlannedTwinIDUpdateAction>,
) => dispatch({ type: SET_IS_PLANNING_PLANNED_TWIN_ID_UPDATE, payload: status });

const setIsApplyingPlannedTwinIDUpdate = (
  status: boolean,
  dispatch: Dispatch<PlannedTwinIDUpdateAction>,
) => dispatch({ type: SET_IS_APPLYING_PLANNED_TWIN_ID_UPDATE, payload: status });

export const setPlannedTwinIDUpdateMode = (
  plannedTwinIDUpdateMode: PlannedTwinIDUpdateMode,
  dispatch: Dispatch<PlannedTwinIDUpdateAction>,
) => {
  dispatch({
    type: SET_PLANNED_TWIN_ID_UPDATE_MODE,
    payload: plannedTwinIDUpdateMode,
  });
};

export const planPlannedTwinIDs = async (
  name: string,
  csv: string,
  tenant: string,
  projectCode: string,
  assetType: string,
  planID: string,
  plannedTwinIDUpdateMode: PlannedTwinIDUpdateMode,
  dispatch: Dispatch<PlannedTwinIDUpdateAction>,
) => {
  setPlannedTwinIDUpdateFile(name, csv, dispatch);
  setIsPlanningPlannedTwinIDUpdate(true, dispatch);
  analytics.trackEvent('PlannedTwinID Update Tool Plan', { mode: plannedTwinIDUpdateMode });
  try {
    const updateRes = await updatePlannedTwinIDs(
      csv,
      tenant,
      projectCode,
      assetType,
      planID,
      plannedTwinIDUpdateMode,
      'plan',
    );
    const fetchRes = await fetchPlannedTwinIDs(
      tenant,
      projectCode,
      assetType,
      planID,
    );
    dispatch({
      type: SET_PLANNED_TWIN_ID_UPDATE_PLAN,
      payload: updateRes,
    });
    dispatch({
      type: SET_EXISTING_PLANNED_TWIN_IDS,
      payload: fetchRes,
    });
  } catch (error) {
    if (!(error instanceof Error)) throw error;
    dispatch({
      type: SET_PLANNED_TWIN_ID_UPDATE_ERROR,
      payload: error,
    });
    throw error;
  } finally {
    setIsPlanningPlannedTwinIDUpdate(false, dispatch);
  }
};

export const applyPlannedTwinIDs = async (
  csv: string,
  tenant: string,
  projectCode: string,
  assetType: string,
  planID: string,
  plannedTwinIDUpdateMode: PlannedTwinIDUpdateMode,
  dispatch: Dispatch<PlannedTwinIDUpdateAction>,
) => {
  setIsApplyingPlannedTwinIDUpdate(true, dispatch);
  analytics.trackEvent('PlannedTwinID Update Tool Apply', { mode: plannedTwinIDUpdateMode });
  try {
    await updatePlannedTwinIDs(
      csv,
      tenant,
      projectCode,
      assetType,
      planID,
      plannedTwinIDUpdateMode,
      'apply',
    );
    dispatch({
      type: RESET_PLANNED_TWIN_ID_UPDATE,
    });
  } finally {
    setIsApplyingPlannedTwinIDUpdate(false, dispatch);
  }
};

export const resetPlannedTwinIDUpdate = (dispatch: Dispatch<PlannedTwinIDUpdateAction>) => {
  dispatch({
    type: RESET_PLANNED_TWIN_ID_UPDATE,
  });
};

export const setPlannedTwinIDUpdateShowChangesOnly = (
  showChangesOnly: boolean,
  dispatch: Dispatch<PlannedTwinIDUpdateAction>,
) => {
  dispatch({
    type: SET_PLANNED_TWIN_ID_UPDATE_SHOW_CHANGES_ONLY,
    payload: showChangesOnly,
  });
};
